import { Inject } from '@odinjs/odin';

import { Endpoint, FOUNDATION_ROUTES, Route } from '@philips-emr/hpms-stipulator-commons';
import { HPMSOnSubmitTermoUso } from '@philips-emr/hpms-stipulator-components/lib/events/event';
import { FetchAPI } from '@philips-emr/tws-components';
import Controller, { OnClose, OnMount } from '@philips-emr/tws-core/lib/client';
import { AuthenticationService, HttpService } from '@philips-emr/tws-core/lib/services';
import { applicationContext } from '@philips-emr/tws-foundation';

import BaseController from './BaseController';

interface TermoUso {
  nrSeqTermo: number;
  nrSeqTermoUso: number;
}

@Controller({ fragment: 'assign-aviso-de-privacidade', component: 'assign-aviso-de-privacidade-modal' })
class AssignAvisoDePrivacidadeModalController extends BaseController {

  @Inject('fetch-hpms-aviso')
  private fetchTermoUso: FetchAPI;

  @OnMount({ target: ['assign-aviso-de-privacidade-modal'] })
  onMount(): void {
    const { nrSeqAviso } = this.historyService.getCurrentRouteParams();
    this.context.set({ nrSeqAviso });
    const nrSeqValid = nrSeqAviso !== 'undefined';
    if (nrSeqValid) {
      this.fetchTermoUso.forceFetch();
    }
  }

  @OnClose({ target: ['assign-aviso-de-privacidade-modal'] })
  onclose(): void {
    void AuthenticationService.logout().then(() => {
      this.historyService.push(FOUNDATION_ROUTES.LOGIN);
    });
  }

  @HPMSOnSubmitTermoUso('hpms-aviso-service')
  onSubmitTermoUso(): void {
    const { nrSeqAviso } = this.historyService.getCurrentRouteParams();

    if (nrSeqAviso !== 'undefined') {
      void HttpService.put(Endpoint.PUT.CONFIRMAR_LEITURA_AVISO_DE_PRIVACIDADE, { nrSeqAviso }).then(() => {
        void this.checkTermosdeUso();
      });
    }
  }

  private async checkTermosdeUso(): Promise<void> {
    await HttpService.get(Endpoint.GET.CHECK_TERMOS_USO).then(async (result) => {
      const { nrSeqTermoUso } = result.body as TermoUso;
      if (!nrSeqTermoUso) {
        await HttpService.get(Endpoint.GET.TERMO_USO_ATUAL).then(resp => {
          const { nrSeqTermoUso } = resp.body as TermoUso;
          if (nrSeqTermoUso) {
            this.context.set({ nrSeqTermo: nrSeqTermoUso });
            this.historyService.push(Route.ASSIGN_TERMO_DE_USO, { nrSeqTermo: nrSeqTermoUso });
          } else {
            applicationContext.openModule('inicio');
          }
        });
      } else {
        applicationContext.openModule('inicio');
      }
    });
  }

}

export default AssignAvisoDePrivacidadeModalController;
